module.exports = __webpack_public_path__ + "img/rule-hk.c18c416c.png";